// Shared look of the native-app startup takeover screens: the ToS/app-usage
// screen (AppUsageModal) and the cookie-consent screen render back-to-back on
// first launch and must read as siblings. Both spread this and add their own
// z-index (theme.zIndex.modal — above TopBar at 10 and the
// BottomNavigationBar at theme.zIndex.drawer).
export const startupScreenSx = {
  bgcolor: 'background.paper',
  bottom: 0,
  boxShadow: 3,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  left: 0,
  p: 3,
  pb: 'calc(env(safe-area-inset-bottom, 0px) + 24px)',
  position: 'fixed',
  right: 0,
  top: 0,
};
